export default "__VITE_ASSET__BxbDY_E___"